import axios from 'axios';

/* se obtiene el location de la url */
const location = window.location.origin;
const hostname = window.location.hostname;
let baseURL = process.env.REACT_APP_API_URL;


/* se configura la cabecera para que axios pueda realizar las peticiones utilizando el token correspondiente */
if (hostname === "test.kigafe.com") {
    baseURL = process.env.REACT_APP_API_URL_TEST;
}else if (hostname === "prod.kigafe.com") {
    baseURL = process.env.REACT_APP_API_URL;
}else if (location.includes("modiga")) {
    baseURL = process.env.REACT_APP_API_URL;
} else if (location.includes("antell")) {
    baseURL = process.env.REACT_APP_API_URL_ANTELL;
} else if (location.includes("dpm")) {
    baseURL = process.env.REACT_APP_API_URL_DPM;
} else if (location.includes("eglobalt")) {
    baseURL = process.env.REACT_APP_API_URL_EGLOBALT;
}else if (location.includes("mickey")) {
    baseURL = process.env.REACT_APP_API_URL_MICKEY;
}else if (location.includes("toval")) {
    baseURL = process.env.REACT_APP_API_URL_TOVAL;
}else if (location.includes("monchis")) {
    baseURL = process.env.REACT_APP_API_URL_MONCHIS;
}else if (location.includes("itacoty")) {
    baseURL = process.env.REACT_APP_API_URL_ITA_COTY;
}else if (location.includes("dcordillera")) {
    baseURL = process.env.REACT_APP_API_URL_CORDILLERA;
}else if (location.includes("opticasantalucia")) {
    baseURL = process.env.REACT_APP_API_URL_SLUCIA;
}else if (location.includes("mediplan")) {
    baseURL = process.env.REACT_APP_API_URL_MEDIPLAN;
}else if (location.includes("ampac")) {
    baseURL = process.env.REACT_APP_API_URL_AMPAC;
}else if (location.includes("acisa")) {
    baseURL = process.env.REACT_APP_API_URL_ACISA;
}else if (location.includes("aban")) {
    baseURL = process.env.REACT_APP_API_URL_ABAN;
}else if (location.includes("unnaki")) {
    baseURL = process.env.REACT_APP_API_URL_UNNAKI;
}else if (location.includes("efete")) {
    baseURL = process.env.REACT_APP_API_URL_EFETE;
}else if (location.includes("sanpatricio")) {
    baseURL = process.env.REACT_APP_API_URL_SAN_PATRICIO;
}else if (location.includes("diprocar")) {
    baseURL = process.env.REACT_APP_API_URL_DIPROCAR;
}else if (location.includes("pyainmobiliaria")) {
    baseURL = process.env.REACT_APP_API_URL_PYA_INMOBILIARIA;
}else if (location.includes("mariam")) {
    baseURL = process.env.REACT_APP_API_URL_MARIAM;
}else if (location.includes("automotive")) {
    baseURL = process.env.REACT_APP_API_URL_AUTOMOTIVE;
}else if (location.includes("inmobiliariageneral")) {
    baseURL = process.env.REACT_APP_API_URL_INMOBILIARIA_GENERAL;
}else if (location.includes("foodcleaning")) {
    baseURL = process.env.REACT_APP_API_URL_FOOD_CLEANING;
}else if (location.includes("craft")) {
    baseURL = process.env.REACT_APP_API_URL_CRAFT;
}else if (location.includes("envacotest")) {
    baseURL = process.env.REACT_APP_API_URL_ENVACO_TEST;
}else if (location.includes("envaco")) {
    baseURL = process.env.REACT_APP_API_URL_ENVACO;
}else if (location.includes("fluoder")) {
    baseURL = process.env.REACT_APP_API_URL_FLUODER;
}

const instance = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-type': 'application/json'
    }
});

instance.interceptors.request.use(async (config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
    return config;
});

instance.interceptors.response.use(response => {
    return response;
}, error => {

    return Promise.reject(error.response.data);
});

export const signup = (data) => {
    return instance.post('/login', data, {
        params: {
            plataforma: 'KUDE'
        }
    })
        .then((response) => {
            /* se almacenan los datos del usuario logueado en el localstorage */
            if (response.data.accessToken) {
                localStorage.setItem('user', JSON.stringify(response.data));
                localStorage.setItem('isLoggin', true);
                localStorage.setItem('accessToken', response.data.accessToken);
            }
            return response.data;
        });

};

export const getUserInfo = (token) => {
    return instance.get(`/usuarios/consultausuario?accessToken=${token}`);
}

export const getListaComprobantes = (idEmpresa, ruc) => {
    return instance.get(`/comprobantes/consultacomprobanteempresaruc?idEmpresa=${idEmpresa}&ruc=${ruc}`);
}

export const crearUsuario = (body) => {
    return instance.post(`/usuarios`, body, {
        params: {
            plataforma: 'KUDE'
        }
    });
}

export const obtenerComprobantes = (body) => {
    return instance.get(`/comprobantes/consultaportal?nrocomprobante=${body.nroComprobante}&nrotimbrado=${body.timbrado}&tipoComprobante=${body.tipoComprobante}`);
}

